import type { LimitStatus } from '../lib/limitStatus';
import { limitLabel } from '../lib/limitStatus';

/**
 * 台股漲跌停徽章：紅底白字（漲停）/ 綠底白字（跌停），看盤軟體慣例，一眼辨識鎖死。
 * 美股沒有漲跌停制度，呼叫端先用 limitStatus() 判斷後才渲染。
 */
export function LimitTag({ status, className = '' }: { status: LimitStatus; className?: string }) {
  return (
    <span
      className={`limit-tag ${status} ${className}`}
      title={status === 'up' ? '台股漲停（貼著 +10% 鎖死）' : '台股跌停（貼著 −10% 鎖死）'}
    >
      🔒 {limitLabel(status)}
    </span>
  );
}
